import React from 'react'
// import cookie from 'js-cookie'
import { useTranslation } from 'react-i18next'
import { updateLangPrefer } from '../../api/user'
import { MenuItem } from '@blueprintjs/core'

const LanguageSelector = () => {
  const { i18n } = useTranslation()

  const updateLang = async (value) => {
    // cookie.set('lang', value)
    localStorage.setItem("webshop-lang",value)
    updateLangPrefer({ langPrefer: value }).then(data => {
      if (data.P_RESULT_CODE === 0) {
        const appHref = document.location.href.split('/')
        const appUrl = appHref.pop()
        if(appUrl === 'home'){
          document.location.reload(true)
        }
      }
    })
  }

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang)
    updateLang(lang)
  }

  return (
    <>
      <MenuItem text='Türkçe' active={i18n.language === 'tr'} onClick={() => changeLanguage('tr')} />
      <MenuItem text='English' active={i18n.language === 'en'} onClick={() => changeLanguage('en')} />
    </>
  )
}

export default LanguageSelector
